<template>
  <div class="layout-container">
    <!-- 添加网站头部 -->
    <div class="layout-header">
      <AppHeader />
    </div>
    <div class="layout-content">
      <!-- 主内容区域 -->
      <router-view v-slot="{ Component }">
        <keep-alive :include="cachedViews">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>

    <!-- 添加悬浮按钮 -->
    <FloatingButton v-show="showFloatingButton" :to="floatingButtonTarget" :text="$t('page.home.membership.button')"
      :dark-mode="floatingButtonDarkMode" />

    <!-- 收益计算器悬浮按钮 -->
    <CalculatorFloatingButton v-show="showCalculatorButton" />

  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import AppHeader from '@/components/custom/AppHeader.vue'
import FloatingButton from '@/components/custom/FloatingButton.vue'
import CalculatorFloatingButton from '@/components/custom/CalculatorFloatingButton.vue'
import { useRoute } from 'vue-router'

defineOptions({
  name: 'DefaultLayout'
})
// 缓存的视图
const cachedViews = computed(() => {
  return ['Dashboard']
})

const route = useRoute()

// 悬浮按钮配置
const floatingButtonTarget = ref('/contact')
const floatingButtonDarkMode = ref(false)

const notShowFloatingButtonMap = ['/contact']

const showFloatingButton = computed(() => {
  return !notShowFloatingButtonMap.includes(route.path)
})

// 计算器按钮配置 - 在所有页面显示
const showCalculatorButton = computed(() => {
  return true // 在所有页面都显示
})

</script>

<style scoped lang="scss">
.layout-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  // max-width: 1920px;
  margin: 0 auto;
  position: relative;
  transform-origin: center top;

  .layout-header {
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 1000;
  }

  .layout-content {
    flex: 1;
    width: 100%;
    overflow-x: hidden;
  }

  .layout-footer {
    width: 100%;
  }
}

// 响应式处理
@media (max-width: 1920px) and (min-width: 768px) {
  .layout-container {
    transform: scale(calc(100vw / 1920));
    transform-origin: left top;
    width: 100vw;
    height: auto;
    min-height: 100vh;
  }
}

@media (min-width: 1920px) {
  .layout-container {
    width: 100%;
    height: auto;
    min-height: 100vh;
  }
}

@media (max-width: 768px) {
  .layout-container {
    transform: none;
    width: 100%;
    height: auto;
  }
}
</style>